import Link from 'next/link';

const WordmarkSVG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='100'
    height='40'
    viewBox='0 0 146 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M30 28.3H20.0167C18.1833 28.3 16.7667 29.8667 15.8833 31.4667C15.1841 32.7787 14.0663 33.8194 12.7077 34.4233C11.3491 35.0271 9.82762 35.1595 8.38513 34.7994C6.94264 34.4392 5.66193 33.6072 4.74659 32.4356C3.83125 31.264 3.33381 29.8201 3.33334 28.3333C3.35001 27.1667 3.66668 26 4.28334 25'
      stroke='#3b82f6'
      strokeWidth='3.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 28.3351L15.2167 18.7018C16.1 17.0851 15.3833 15.0684 14.3833 13.5351C13.9114 12.7803 13.5953 11.9386 13.4539 11.0596C13.3125 10.1807 13.3486 9.28232 13.56 8.41754C13.7714 7.55276 14.1538 6.73909 14.6848 6.02451C15.2158 5.30994 15.8845 4.70895 16.6515 4.257C17.4184 3.80504 18.2682 3.51128 19.1505 3.39304C20.0329 3.27481 20.93 3.33449 21.7889 3.56857C22.6478 3.80265 23.4511 4.20639 24.1515 4.75597C24.8519 5.30554 25.435 5.98982 25.8667 6.76843'
      stroke='#3b82f6'
      strokeWidth='3.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 10L25.2167 19.55C26.1 21.1667 28.1667 21.6667 30 21.6667C31.7681 21.6667 33.4638 22.369 34.714 23.6193C35.9643 24.8695 36.6667 26.5652 36.6667 28.3333C36.6667 30.1014 35.9643 31.7971 34.714 33.0474C33.4638 34.2976 31.7681 35 30 35'
      stroke='#3b82f6'
      strokeWidth='3.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M55.8575 32H52.8366L61.5739 8.20462H64.5483L73.2857 32H70.2648L63.1541 11.9691H62.9682L55.8575 32ZM56.9729 22.7049H69.1494V25.2611H56.9729V22.7049ZM88.977 14.1535L82.3775 32H79.5889L72.9894 14.1535H75.9639L80.8902 28.3749H81.0761L86.0025 14.1535H88.977ZM99.2073 32.3718C97.5962 32.3718 96.1826 31.9884 94.9665 31.2215C93.7581 30.4547 92.8131 29.3819 92.1315 28.0031C91.4576 26.6244 91.1206 25.0132 91.1206 23.1697C91.1206 21.3107 91.4576 19.6879 92.1315 18.3014C92.8131 16.9149 93.7581 15.8382 94.9665 15.0714C96.1826 14.3045 97.5962 13.9211 99.2073 13.9211C100.818 13.9211 102.228 14.3045 103.437 15.0714C104.653 15.8382 105.598 16.9149 106.272 18.3014C106.953 19.6879 107.294 21.3107 107.294 23.1697C107.294 25.0132 106.953 26.6244 106.272 28.0031C105.598 29.3819 104.653 30.4547 103.437 31.2215C102.228 31.9884 100.818 32.3718 99.2073 32.3718ZM99.2073 29.9086C100.431 29.9086 101.438 29.5949 102.228 28.9675C103.018 28.3401 103.603 27.5151 103.983 26.4927C104.362 25.4702 104.552 24.3625 104.552 23.1697C104.552 21.9768 104.362 20.8653 103.983 19.8351C103.603 18.8049 103.018 17.9722 102.228 17.337C101.438 16.7019 100.431 16.3843 99.2073 16.3843C97.9835 16.3843 96.9765 16.7019 96.1864 17.337C95.3964 17.9722 94.8115 18.8049 94.432 19.8351C94.0525 20.8653 93.8627 21.9768 93.8627 23.1697C93.8627 24.3625 94.0525 25.4702 94.432 26.4927C94.8115 27.5151 95.3964 28.3401 96.1864 28.9675C96.9765 29.5949 97.9835 29.9086 99.2073 29.9086ZM118.73 32.3718C117.057 32.3718 115.616 31.9768 114.408 31.1867C113.199 30.3966 112.27 29.3083 111.619 27.9218C110.969 26.5353 110.643 24.9512 110.643 23.1697C110.643 21.3571 110.976 19.7576 111.642 18.3711C112.316 16.9768 113.254 15.8885 114.454 15.1062C115.663 14.3161 117.072 13.9211 118.683 13.9211C119.938 13.9211 121.069 14.1535 122.076 14.6182C123.083 15.083 123.908 15.7336 124.551 16.5702C125.194 17.4067 125.593 18.3827 125.748 19.4981H123.006C122.796 18.6848 122.332 17.9644 121.611 17.337C120.899 16.7019 119.938 16.3843 118.73 16.3843C117.661 16.3843 116.724 16.6631 115.918 17.2208C115.12 17.7708 114.497 18.5493 114.048 19.5562C113.606 20.5554 113.385 21.7289 113.385 23.0767C113.385 24.4555 113.602 25.6561 114.036 26.6786C114.477 27.701 115.097 28.495 115.895 29.0604C116.7 29.6259 117.645 29.9086 118.73 29.9086C119.443 29.9086 120.089 29.7847 120.67 29.5368C121.251 29.2889 121.743 28.9326 122.146 28.4679C122.549 28.0031 122.835 27.4454 123.006 26.7948H125.748C125.593 27.8482 125.209 28.7971 124.597 29.6414C123.993 30.4779 123.192 31.1441 122.192 31.6398C121.201 32.1278 120.047 32.3718 118.73 32.3718ZM135.008 32.4183C133.877 32.4183 132.851 32.2053 131.929 31.7792C131.007 31.3455 130.275 30.7219 129.733 29.9086C129.191 29.0875 128.92 28.0961 128.92 26.9342C128.92 25.9117 129.121 25.0829 129.524 24.4478C129.927 23.8048 130.465 23.3014 131.139 22.9373C131.813 22.5732 132.556 22.3021 133.37 22.124C134.191 21.9381 135.016 21.7909 135.844 21.6825C136.929 21.543 137.808 21.4385 138.482 21.3688C139.164 21.2913 139.659 21.1635 139.969 20.9853C140.287 20.8072 140.446 20.4973 140.446 20.0558V19.9629C140.446 18.8165 140.132 17.9257 139.504 17.2905C138.885 16.6554 137.944 16.3378 136.681 16.3378C135.372 16.3378 134.346 16.6244 133.602 17.1976C132.858 17.7708 132.336 18.3827 132.033 19.0334L129.431 18.1039C129.896 17.0194 130.515 16.1751 131.29 15.571C132.072 14.959 132.924 14.533 133.846 14.2929C134.776 14.045 135.69 13.9211 136.588 13.9211C137.161 13.9211 137.82 13.9908 138.563 14.1302C139.315 14.2619 140.039 14.5369 140.736 14.9552C141.441 15.3734 142.026 16.0047 142.49 16.849C142.955 17.6933 143.188 18.8242 143.188 20.2417V32H140.446V29.5833H140.306C140.12 29.9706 139.81 30.385 139.377 30.8265C138.943 31.268 138.366 31.6437 137.645 31.9535C136.925 32.2634 136.046 32.4183 135.008 32.4183ZM135.426 29.9551C136.511 29.9551 137.425 29.7421 138.168 29.316C138.92 28.89 139.485 28.3401 139.865 27.6662C140.252 26.9923 140.446 26.2835 140.446 25.5399V23.0303C140.329 23.1697 140.074 23.2975 139.679 23.4137C139.291 23.5221 138.842 23.6189 138.331 23.7041C137.827 23.7816 137.336 23.8513 136.855 23.9133C136.383 23.9675 135.999 24.014 135.705 24.0527C134.992 24.1457 134.326 24.2967 133.707 24.5058C133.095 24.7072 132.599 25.0132 132.219 25.4237C131.848 25.8265 131.662 26.3765 131.662 27.0736C131.662 28.0264 132.014 28.7467 132.719 29.2347C133.432 29.715 134.334 29.9551 135.426 29.9551Z'
      fill='#3b82f6'
    />
  </svg>
);

const LogoSVG = ({ className }: { className?: string }) => (
  <svg
    className={`${className}`}
    xmlns='http://www.w3.org/2000/svg'
    version='1.1'
    width='40'
    height='40'
    viewBox='0 0 812 799'
  >
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#fefefe'
        d='M -0.5,-0.5 C 199.5,-0.5 399.5,-0.5 599.5,-0.5C 593.397,1.26898 587.731,4.10231 582.5,8C 534.5,56 486.5,104 438.5,152C 450.461,153.308 462.461,153.808 474.5,153.5C 484.494,154.167 494.661,154.5 505,154.5C 520.694,154.66 536.194,153.993 551.5,152.5C 556.562,152.726 561.562,152.392 566.5,151.5C 580.72,151.507 594.72,150.507 608.5,148.5C 631.94,146.675 655.274,144.008 678.5,140.5C 682.764,140.656 686.764,139.989 690.5,138.5C 714.982,135.566 739.315,131.899 763.5,127.5C 767.93,126.401 772.264,125.401 776.5,124.5C 781.821,123.671 787.154,122.838 792.5,122C 795.281,121.478 797.615,120.311 799.5,118.5C 805.232,111.47 807.898,103.303 807.5,94C 808.051,85.4912 805.717,77.9912 800.5,71.5C 796.102,65.2833 790.435,60.45 783.5,57C 727.297,38.047 671.297,18.8803 615.5,-0.5C 680.833,-0.5 746.167,-0.5 811.5,-0.5C 811.5,265.833 811.5,532.167 811.5,798.5C 540.833,798.5 270.167,798.5 -0.5,798.5C -0.5,532.167 -0.5,265.833 -0.5,-0.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#3b8afe'
        d='M 599.5,-0.5 C 604.833,-0.5 610.167,-0.5 615.5,-0.5C 671.297,18.8803 727.297,38.047 783.5,57C 790.435,60.45 796.102,65.2833 800.5,71.5C 801.389,75.1213 802.722,78.6213 804.5,82C 804.355,83.2259 804.022,84.3926 803.5,85.5C 804.227,89.9611 805.227,94.2945 806.5,98.5C 805.935,103.73 805.102,103.73 804,98.5C 803.059,104.617 800.892,110.284 797.5,115.5C 798.612,116.265 799.279,117.265 799.5,118.5C 797.615,120.311 795.281,121.478 792.5,122C 787.154,122.838 781.821,123.671 776.5,124.5C 772.486,124.334 768.486,124.501 764.5,125C 763.748,125.671 763.414,126.504 763.5,127.5C 739.315,131.899 714.982,135.566 690.5,138.5C 687.15,138.335 683.817,138.502 680.5,139C 679.584,139.278 678.918,139.778 678.5,140.5C 655.274,144.008 631.94,146.675 608.5,148.5C 594.315,148.966 580.315,149.966 566.5,151.5C 561.562,152.392 556.562,152.726 551.5,152.5C 525.839,153.198 500.173,153.531 474.5,153.5C 462.461,153.808 450.461,153.308 438.5,152C 486.5,104 534.5,56 582.5,8C 587.731,4.10231 593.397,1.26898 599.5,-0.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#488df4'
        d='M 800.5,71.5 C 805.717,77.9912 808.051,85.4912 807.5,94C 807.898,103.303 805.232,111.47 799.5,118.5C 799.279,117.265 798.612,116.265 797.5,115.5C 800.892,110.284 803.059,104.617 804,98.5C 805.102,103.73 805.935,103.73 806.5,98.5C 805.227,94.2945 804.227,89.9611 803.5,85.5C 804.022,84.3926 804.355,83.2259 804.5,82C 802.722,78.6213 801.389,75.1213 800.5,71.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#5a95ea'
        d='M 776.5,124.5 C 772.264,125.401 767.93,126.401 763.5,127.5C 763.414,126.504 763.748,125.671 764.5,125C 768.486,124.501 772.486,124.334 776.5,124.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#3c8afe'
        d='M 14.5,232.5 C 14.6224,225.804 14.7891,219.138 15,212.5C 14.3308,215.267 13.1641,215.767 11.5,214C 11.8333,213 12.1667,212 12.5,211C 11.4723,207.545 10.139,204.379 8.5,201.5C 5.78336,191.086 3.61669,180.419 2,169.5C -0.40587,148.809 7.7608,133.976 26.5,125C 30.017,123.266 33.6836,122.599 37.5,123C 117.206,209.299 187.039,302.799 247,403.5C 249.474,408.11 251.641,412.777 253.5,417.5C 189.363,401.107 125.363,384.274 61.5,367C 47.8371,362.003 39.0037,352.503 35,338.5C 27.8419,303.206 21.0086,267.873 14.5,232.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#6094e8'
        d='M 690.5,138.5 C 686.764,139.989 682.764,140.656 678.5,140.5C 678.918,139.778 679.584,139.278 680.5,139C 683.817,138.502 687.15,138.335 690.5,138.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#3b8afe'
        d='M 234.5,165.5 C 235.987,169.923 238.487,170.923 242,168.5C 250.092,169.779 258.259,170.612 266.5,171C 268.551,172.423 270.551,173.923 272.5,175.5C 273.478,175.023 274.311,174.357 275,173.5C 275.674,174.578 276.674,175.245 278,175.5C 283.129,174.631 288.296,174.298 293.5,174.5C 311.537,176.061 329.537,178.061 347.5,180.5C 348.609,181.29 349.942,181.79 351.5,182C 357.825,182.5 364.158,182.666 370.5,182.5C 383.15,183.411 395.816,184.078 408.5,184.5C 414.261,186.057 420.261,186.724 426.5,186.5C 471.166,189.157 515.833,189.157 560.5,186.5C 570.853,186.45 581.186,185.95 591.5,185C 593.058,184.79 594.391,184.29 595.5,183.5C 601.81,182.81 608.143,182.476 614.5,182.5C 630.899,181.495 647.232,179.828 663.5,177.5C 665.64,177.444 667.306,176.777 668.5,175.5C 679.496,174.167 690.496,172.834 701.5,171.5C 706.874,171.477 712.207,170.977 717.5,170C 718.416,169.722 719.082,169.222 719.5,168.5C 733.794,165.922 748.127,163.588 762.5,161.5C 765.082,161.025 767.082,161.692 768.5,163.5C 666.652,264.126 581.152,376.793 512,501.5C 483.463,557.718 457.629,615.051 434.5,673.5C 433.022,673.238 431.689,673.571 430.5,674.5C 429.894,676.709 429.227,678.876 428.5,681C 427.207,681.49 425.873,681.657 424.5,681.5C 425.092,687.958 424.092,688.624 421.5,683.5C 419.164,685.23 419.164,686.73 421.5,688C 419.771,689.789 419.104,691.956 419.5,694.5C 418.5,694.5 417.5,694.5 416.5,694.5C 417.167,692.167 417.833,689.833 418.5,687.5C 417.127,687.343 415.793,687.51 414.5,688C 414.603,693.944 414.936,699.944 415.5,706C 413.98,709.612 413.146,713.445 413,717.5C 411.984,716.366 411.317,716.699 411,718.5C 411.438,715.94 411.271,713.44 410.5,711C 409.212,710.761 408.212,711.261 407.5,712.5C 371.74,580.005 318.24,455.338 247,338.5C 199.73,265.507 147.23,196.341 89.5,131C 137.531,144.103 185.865,155.603 234.5,165.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#5b93e9'
        d='M 608.5,148.5 C 594.72,150.507 580.72,151.507 566.5,151.5C 580.315,149.966 594.315,148.966 608.5,148.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#598ee3'
        d='M 551.5,152.5 C 536.194,153.993 520.694,154.66 505,154.5C 494.661,154.5 484.494,154.167 474.5,153.5C 500.173,153.531 525.839,153.198 551.5,152.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#699ae5'
        d='M 768.5,163.5 C 767.082,161.692 765.082,161.025 762.5,161.5C 765.633,160.257 768.967,159.757 772.5,160C 771.295,161.376 769.962,162.542 768.5,163.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#488df4'
        d='M 234.5,165.5 C 254.37,167.999 274.037,170.999 293.5,174.5C 288.296,174.298 283.129,174.631 278,175.5C 276.674,175.245 275.674,174.578 275,173.5C 274.311,174.357 273.478,175.023 272.5,175.5C 270.551,173.923 268.551,172.423 266.5,171C 258.259,170.612 250.092,169.779 242,168.5C 238.487,170.923 235.987,169.923 234.5,165.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#6a99e9'
        d='M 719.5,168.5 C 719.082,169.222 718.416,169.722 717.5,170C 712.207,170.977 706.874,171.477 701.5,171.5C 707.331,170.271 713.331,169.271 719.5,168.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#5b92ea'
        d='M 668.5,175.5 C 667.306,176.777 665.64,177.444 663.5,177.5C 647.232,179.828 630.899,181.495 614.5,182.5C 632.391,180.392 650.391,178.058 668.5,175.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#6297ed'
        d='M 347.5,180.5 C 355.365,180.571 363.031,181.238 370.5,182.5C 364.158,182.666 357.825,182.5 351.5,182C 349.942,181.79 348.609,181.29 347.5,180.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#6a9deb'
        d='M 408.5,184.5 C 414.712,184.523 420.712,185.19 426.5,186.5C 420.261,186.724 414.261,186.057 408.5,184.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#5e95ea'
        d='M 595.5,183.5 C 594.391,184.29 593.058,184.79 591.5,185C 581.186,185.95 570.853,186.45 560.5,186.5C 572,185.272 583.667,184.272 595.5,183.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#5292f4'
        d='M 8.5,201.5 C 10.139,204.379 11.4723,207.545 12.5,211C 12.1667,212 11.8333,213 11.5,214C 13.1641,215.767 14.3308,215.267 15,212.5C 14.7891,219.138 14.6224,225.804 14.5,232.5C 11.7696,222.429 9.76961,212.095 8.5,201.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#3c8afe'
        d='M 592.5,458.5 C 591.302,462.488 591.302,466.488 592.5,470.5C 594.471,472.275 595.804,474.442 596.5,477C 594.962,480.021 594.462,483.188 595,486.5C 595.739,484.779 596.573,483.113 597.5,481.5C 598.011,483.884 599.011,485.884 600.5,487.5C 613.617,534.626 626.451,581.96 639,629.5C 642.204,643.481 639.538,656.148 631,667.5C 587.5,705.667 544,743.833 500.5,782C 495.366,785.985 489.699,788.818 483.5,790.5C 476.5,790.5 469.5,790.5 462.5,790.5C 451.938,787.773 443.771,781.773 438,772.5C 437.125,771.127 436.625,769.627 436.5,768C 467.89,670.404 508.39,576.904 558,487.5C 568,472.167 578,456.833 588,441.5C 590.282,446.963 591.782,452.629 592.5,458.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#4e8ff2'
        d='M 592.5,458.5 C 595.924,467.854 598.591,477.521 600.5,487.5C 599.011,485.884 598.011,483.884 597.5,481.5C 596.573,483.113 595.739,484.779 595,486.5C 594.462,483.188 594.962,480.021 596.5,477C 595.804,474.442 594.471,472.275 592.5,470.5C 591.302,466.488 591.302,462.488 592.5,458.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#408bfa'
        d='M 434.5,673.5 C 427.567,693.296 420.234,712.963 412.5,732.5C 410.008,726.026 408.341,719.36 407.5,712.5C 408.212,711.261 409.212,710.761 410.5,711C 411.271,713.44 411.438,715.94 411,718.5C 411.317,716.699 411.984,716.366 413,717.5C 413.146,713.445 413.98,709.612 415.5,706C 414.936,699.944 414.603,693.944 414.5,688C 415.793,687.51 417.127,687.343 418.5,687.5C 417.833,689.833 417.167,692.167 416.5,694.5C 417.5,694.5 418.5,694.5 419.5,694.5C 419.104,691.956 419.771,689.789 421.5,688C 419.164,686.73 419.164,685.23 421.5,683.5C 424.092,688.624 425.092,687.958 424.5,681.5C 425.873,681.657 427.207,681.49 428.5,681C 429.227,678.876 429.894,676.709 430.5,674.5C 431.689,673.571 433.022,673.238 434.5,673.5 Z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill='#6599ed'
        d='M 462.5,790.5 C 469.5,790.5 476.5,790.5 483.5,790.5C 476.5,793.167 469.5,793.167 462.5,790.5 Z'
      />
    </g>
  </svg>
);

export default function Logo({
  className,
  logoClassName,
  variant,
  linkToHome = false,
}: {
  className?: string;
  logoClassName?: string;
  variant: 'logo' | 'wordmark';
  linkToHome?: boolean;
}) {
  const component = <LogoSVG className={logoClassName} />;
  if (linkToHome)
    return (
      <Link href={'/'} className={''}>
        {component}
      </Link>
    );

  return component;
}
